<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Handle, Position } from '@vue-flow/core';
import { sourceHandles } from '../useAgentFlowGraph';

const props = defineProps({
  id: { type: String, required: true },
  type: { type: String, required: true },
  data: { type: Object, default: () => ({}) },
});

const { t } = useI18n();

const typeLabel = computed(() =>
  t(`AI_AGENTS.FLOW_EDITOR.NODE.${props.type.toUpperCase()}`)
);

const summary = computed(() => {
  const d = props.data || {};
  if (props.type === 'override_agent') return d.label || '';
  if (props.type === 'dispatch_tool') return d.tool_id || '';
  if (props.type === 'agent_transfer') {
    return d.target_brain_id ? `#${d.target_brain_id}` : '';
  }
  if (props.type === 'transfer_to_number') return d.phone || '';
  return '';
});

const handles = computed(() =>
  sourceHandles({ type: props.type, data: props.data })
);
const isSingleHandle = computed(() => handles.value.length === 1);
</script>

<template>
  <div
    class="min-w-[160px] rounded-lg border border-n-weak bg-n-solid-1 px-3 py-2 shadow-sm"
  >
    <Handle v-if="type !== 'start'" type="target" :position="Position.Left" />
    <p class="text-xs font-semibold uppercase tracking-wide text-n-slate-11">
      {{ typeLabel }}
    </p>
    <p v-if="summary" class="mt-0.5 text-sm text-n-slate-12 truncate">
      {{ summary }}
    </p>

    <Handle
      v-if="isSingleHandle"
      type="source"
      :position="Position.Right"
      data-handle-id="default"
    />
    <div v-else class="mt-2 flex flex-col gap-1">
      <span
        v-for="handle in handles"
        :key="handle"
        class="relative flex items-center justify-end gap-1 text-xs text-n-slate-11"
      >
        {{ t(`AI_AGENTS.FLOW_EDITOR.HANDLE.${handle.toUpperCase()}`) }}
        <Handle
          :id="handle"
          type="source"
          :position="Position.Right"
          class="!relative !transform-none"
          :data-handle-id="handle"
        />
      </span>
    </div>
  </div>
</template>
